// imports
import { useCallback } from 'react'
import { Button, Dialog } from '@bosch/react-frok'

// components
import useConfirm from '@/hooks/useConfirm'
import type { UnsavedChangesWarningDialogProps } from './types/UnsavedChangesWarningDialogTypes'

// utils

// styles
import './UnsavedChangesWarningDialog.scss'

const UnsavedChangesWarningDialog = ({
    when,
    title,
    message,
    confirmLabel = 'OK',
    cancelLabel = 'Cancel',
}: UnsavedChangesWarningDialogProps) => {
    const { isActive, onConfirm, resetConfirmation } = useConfirm(when)

    const onConfirmAction = useCallback(async (): Promise<void> => {
        onConfirm()
    }, [onConfirm])

    const onResetAction = useCallback(async (): Promise<void> => {
        resetConfirmation()
    }, [resetConfirmation])

    if (isActive) {
        return (
            <div className="prompt-container">
                <Dialog
                    className="prompt-dialog"
                    modal
                    open={isActive}
                    variant="warning"
                    dialogId="prompt-dialog"
                    title={title}
                    onClose={onResetAction}
                >
                    <span className="dialog-message">{message}</span>

                    <div className="action-area">
                        <Button
                            label={confirmLabel}
                            mode="primary"
                            onClick={onConfirmAction}
                        />
                        <Button
                            label={cancelLabel}
                            mode="secondary"
                            onClick={onResetAction}
                        />
                    </div>
                </Dialog>
            </div>
        )
    }
    return null
}

export default UnsavedChangesWarningDialog
